import { Component, Output, EventEmitter, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import * as authActions from '../../../auth/store/auth.actions';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-modale-countdown',
  templateUrl: './modale-countdown.component.html',
  styleUrls: ['./modale-countdown.component.css']
})
export class ModaleCountdownComponent implements OnInit{
  /**Emettitore dell'evento di chiusura */
  @Output() close = new EventEmitter<boolean>();
  counter = 30;
  timeout: any;

  constructor(
    private store: Store<AppState>
  ) { }

  /**Metodo dell'interfaccia OnInit che gestisce il timeout dell'avviso e il countdown da visualizzare */
  ngOnInit() {
    let tempInt = setInterval(() => this.counter--, 1000);
    this.timeout = setTimeout(() => {
      clearInterval(tempInt);
      this.store.dispatch(new authActions.Logout());
      this.close.emit(false);
    }, 30000);
  }

  /**Metodo che emette l'evento di chiusura al click sullo sfondo o sul pulsante relativo*/
  onClose() {
    this.close.emit(true);
    clearTimeout(this.timeout);
    this.timeout = null;
    
  }
}
